import { ThemeProvider, theme, Box } from "@chakra-ui/react";
import Header from "./header";
import Footer from "./footer";
import NavEnglish from "../../components/en/nav";

import React from "react";

export default function IndexLayout({ children }) {
  return (
    <>
      <ThemeProvider theme={theme}>
        {/* 화면이 길이 지면 푸터를 하단으로 배치하기 위함 */}
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <Header />
          {/* 메인 영역이 화면의 빈공간을 차지하도록 조건 flex=1 */}
          <Box as="main" flex="1">
            <main>{children}</main>
          </Box>
          <NavEnglish />
          <Footer />
        </Box>
      </ThemeProvider>
    </>
  );
}
